export default {
  d1gray: [
    '#FCFCFD',
    '#F2F4F7',
    '#EAECF0',
    '#D0D5DD',
    '#98A2B3',
    '#667085',
    '#475467',
    '#344054',
    '#1D2939',
    '#101828'
  ],
  primary: [
    '#F5F2FF',
    '#ECE8FF',
    '#DAD4FF',
    '#C0B1FF',
    '#A285FF',
    '#7842FF',
    '#7530F7',
    '#671EE3',
    '#5618BF',
    '#47169C'
  ],
  error: [
    '#FFFBFA',
    '#FEE4E2',
    '#FECDCA',
    '#FDA29B',
    '#F97066',
    '#F04438',
    '#D92D20',
    '#B42318',
    '#912018',
    '#7A271A'
  ],
  warning: [
    '#FFFCF5',
    '#FEF0C7',
    '#FEDF89',
    '#FEC84B',
    '#FDB022',
    '#F79009',
    '#DC6803',
    '#B54708',
    '#93370D',
    '#7A2E0E'
  ],
  success: [
    '#F6FEF9',
    '#DCFAE6',
    '#A9EFC5',
    '#75E0A7',
    '#47CD89',
    '#17B26A',
    '#079455',
    '#067647',
    '#085D3A',
    '#074D31'
  ],
  d1secondaryblue: [
    '#F5F8FF',
    '#D1E0FF',
    '#B2CCFF',
    '#84ADFF',
    '#528BFF',
    '#2970FF',
    '#155EEF',
    '#004EEB',
    '#0040C1',
    '#00359E'
  ],
  d1secondarypurple: [
    '#FAFAFF',
    '#EBE9FE',
    '#D9D6FE',
    '#BDB4FE',
    '#9B8AFB',
    '#7A5AF8',
    '#6938EF',
    '#5925DC',
    '#4A1FB8',
    '#3E1C96'
  ],
  d1secondarypink: [
    '#FEF6FB',
    '#FCE7F6',
    '#FCCEEE',
    '#FAA7E0',
    '#F670C7',
    '#EE46BC',
    '#DD2590',
    '#C11574',
    '#9E165F',
    '#851651'
  ]
};
